export interface CategoryData {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: CategoryData[] = [
  {
    slug: 'romance',
    name: '恋爱',
    icon: 'ri-heart-line',
    description: '甜到心里的韩国恋爱漫画，心动剧情让你少女心爆棚',
    count: 4,
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    icon: 'ri-magic-line',
    description: '魔法、精灵、异世界，最精彩的奇幻冒险韩国漫画',
    count: 4,
  },
  {
    slug: 'daily',
    name: '日常',
    icon: 'ri-sun-line',
    description: '温馨治愈的日常故事，平凡中藏着最动人的温暖',
    count: 4,
  },
  {
    slug: 'comedy',
    name: '搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '笑到停不下来！轻松搞笑的韩国漫画陪你度过快乐时光',
    count: 0,
  },
  {
    slug: 'action',
    name: '动作',
    icon: 'ri-flashlight-line',
    description: '热血沸腾的动作场面，精彩刺激的韩国漫画等你来看',
    count: 0,
  },
  {
    slug: 'horror',
    name: '悬疑',
    icon: 'ri-moon-line',
    description: '引人入胜的悬疑剧情，让你一话接一话停不下来',
    count: 0,
  },
];